<template>
  <div class="kariSelect">
    <p class="selectTitle">Выберите новую дату следующего платежа</p>
    <div class="select" v-on:click="selectIsOpen = !selectIsOpen">
      <p class="selected">26 ноября 2024 г</p>
      <arrow-right/>
    </div>
    <div class="options" v-if="selectIsOpen">
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
      <p class="option">26 ноября 2024 г</p>
    </div>
  </div>
</template>

<script>
import ArrowRight from '@/assets/svg/arrowRight';
export default {
  name: 'select-input',
  components: { ArrowRight },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      errorCode: 0,
      placeholder: '_______',
      selectIsOpen: false
    };
  },
  computed: {
    value: {
      get () {
        return this.modelValue;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>

<style scoped>
.kariSelect { width: 100% }
.kariSelect>.selectTitle { margin-bottom: 2.13vw }
.kariSelect>.select { border: 1px solid rgba(207, 207, 207, 1); padding: 2.13vw; display: flex; justify-content: space-between; align-items: center; border-radius: 4px; width: calc(48vw - 4.27vw) }
.kariSelect>.select>p { font-size: 4.80vw }
.kariSelect>.options { padding: 5.33vw 4.27vw; border-radius: 4px; box-shadow: 0 0 2.67vw 0 rgba(0, 0, 0, 0.25); width: calc(48vw - 8.53vw); height: calc(53.07vw - 10.67vw); overflow-y: scroll }
.kariSelect>.options>p { margin-bottom: 2.13vw }
.kariSelect>.options>p:last-child { margin-bottom: 0 }

@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  .kariSelect { position: relative }
  .kariSelect>.selectTitle { margin-bottom: 8px }
  .kariSelect>.select { border: 1px solid rgba(207, 207, 207, 1); padding: 8px; display: flex; justify-content: space-between; align-items: center; border-radius: 4px; width: calc(180px - 16px) }
  .kariSelect>.select>p { font-size: 16px }
  .kariSelect>.options { padding: 20px 16px; border-radius: 4px; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25); width: calc(180px - 32px); height: calc(446px - 40px); overflow-y: scroll; position: absolute; top: 75px; left: 0; background-color: white }
  .kariSelect>.options::-webkit-scrollbar { width: 0 }
  .kariSelect>.options>p { margin-bottom: 8px; cursor: pointer}
  .kariSelect>.options>p:hover { background-color: rgba(239, 239, 239, 1) }
  .kariSelect>.options>p:last-child { margin-bottom: 0 }

}

</style>
